module.exports = __webpack_public_path__ + "static/media/african.f260fe77.png";